import { createContext, useCallback, useContext, useMemo, useReducer } from 'react'
import {
  UIActionType,
  createInitialUIState,
  uiReducer,
} from './reducers/uiReducer'

const UIContext = createContext<any>(null)

export function UIProvider({ children }) {
  const [state, dispatch] = useReducer(uiReducer, undefined, createInitialUIState)

  const toggleSidebar = useCallback(() => {
    dispatch({ type: UIActionType.TOGGLE_SIDEBAR })
  }, [])

  const openSidebar = useCallback(() => {
    dispatch({ type: UIActionType.SET_SIDEBAR_OPEN, payload: true })
  }, [])

  const closeSidebar = useCallback(() => {
    dispatch({ type: UIActionType.SET_SIDEBAR_OPEN, payload: false })
  }, [])

  const setSidebarOpen = useCallback((open) => {
    dispatch({ type: UIActionType.SET_SIDEBAR_OPEN, payload: Boolean(open) })
  }, [])

  const setLoading = useCallback((key, value) => {
    dispatch({
      type: UIActionType.SET_LOADING,
      payload: { key, value: Boolean(value) },
    })
  }, [])

  const clearLoading = useCallback((key) => {
    dispatch({ type: UIActionType.RESET_LOADING_KEY, payload: key })
  }, [])

  const isLoading = useCallback(
    (key) => Boolean(key && state.loading[key]),
    [state.loading],
  )

  const value = useMemo(
    () => ({
      sidebarOpen: state.sidebarOpen,
      loading: state.loading,
      toggleSidebar,
      openSidebar,
      closeSidebar,
      setSidebarOpen,
      setLoading,
      clearLoading,
      isLoading,
    }),
    [
      state.sidebarOpen,
      state.loading,
      toggleSidebar,
      openSidebar,
      closeSidebar,
      setSidebarOpen,
      setLoading,
      clearLoading,
      isLoading,
    ],
  )

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>
}

export function useUI() {
  const ctx = useContext(UIContext)
  if (!ctx) throw new Error('useUI must be used within UIProvider')
  return ctx
}
